import { gql } from 'graphql-tag';
import { SirMutationFragment } from '../fragments';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetSirData, IGetSirVars } from '../types';

// Get a single saved SIR query.
export const GET_SIR: TypedDocumentNode<IGetSirData, IGetSirVars> = gql`
  query getSir($input: ReadSirInput!) {
    viewer {
      id
      role
    }
    getSir(input: $input) {
      ...SirMutationFragment
    }
  }
  ${SirMutationFragment}
`;
